import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Form, Input, Popover, Space } from 'antd'
import Picker from 'emoji-picker-react'
import { t } from 'i18next'
import { type ReactElement, useState } from 'react'

export const EmojiPickerFormItem = ({
  name,
  emoji,
  onSelected,
  disabled,
}: {
  name: string
  emoji: string | null
  onSelected: (emoji: string | null) => void
  disabled?: boolean
}): ReactElement => {
  const [open, setOpen] = useState(false)
  return (
    <Form.Item label={t(`アイコン`)} name={name}>
      <Popover
        content={
          <Picker
            onEmojiClick={(emoji) => {
              setOpen(false)
              onSelected(emoji.emoji)
            }}
          />
        }
        open={open}
        trigger="click"
        onOpenChange={(v) => {
          if (disabled === true) {
            return
          }
          setOpen(v)
        }}
      >
        <Input
          style={{
            width: 44,
          }}
          value={emoji ?? ''}
          // allowClear
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
          }}
          readOnly
          // options={[{
          //   key: emoji,
          //   value: '🏢'
          // }]}
        />
      </Popover>
      {disabled !== true && (
        <Space size={'small'} className="ml-1">
          <Button
            size="small"
            type="text"
            className="text-blue-600"
            icon={<EditOutlined />}
            onClick={() => {
              setOpen(true)
            }}
          >
            {t(`選択`)}
          </Button>
          <Button
            size="small"
            type="text"
            className="text-blue-600"
            icon={<DeleteOutlined />}
            onClick={() => {
              onSelected(null)
            }}
          />
        </Space>
      )}
    </Form.Item>
  )
}
